import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

const minWidthDesktop = tokens.breakpoints.desktop + 1

export const HeaderMobileWrapper = styled.div`
  margin: 0px;
  padding-bottom: 56px;

  @media (min-width: ${minWidthDesktop}px) {
    display: none;
  }
`

export const HeaderMobileTitleWrapper = styled.div`
  display: flex;
  align-items: center;

  > span {
    padding-right: 24px;
    cursor: pointer;
  }

  > p {
    font-size: ${tokens.fontSize.medium};
    font-weight: ${tokens.fontWeights.bold};
    line-height: ${tokens.lineHeight.small}%;
    color: ${tokens.colors.dark6};
  }
`

export const HeaderMobileContentWrapper = styled.div`
  position: fixed;
  z-index: 10;
  top: 0;
  background-color: ${tokens.colors.white};
  box-shadow: ${tokens.shadows.downSmall};
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 16px;
`

export const HeaderMobileIconProfileWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${tokens.spacing.verticalXlarge};
  width: ${tokens.spacing.horizontalXlarge};
  border-radius: ${tokens.radius.circular};
  background-color: ${tokens.colors.dark3};
  cursor: pointer;
`

export const HeaderMobileMenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  margin-right: 8px;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${tokens.colors.dark6};
    outline-offset: 2px;
  }
`

export const HeaderMobileLeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`
